import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

function SideBar() {
    const [role, setRole] = useState("");

    useEffect(() => {
        const userRole = sessionStorage.getItem("role");
        setRole(userRole);
    }, []);

    return (
        <div className="sidebar close">
            <ul className="nav-links">
                {role === 'farm' &&
                    <>
                        <li className="sidebar-main-menu">
                            <div className="icon-link">
                                <NavLink to="/farm-dashboard">
                                    <i className="ti ti-chart-histogram"></i>
                                </NavLink>
                            </div>
                        </li>
                        <li className="sidebar-main-menu">
                            <div className="icon-link">
                                <NavLink to="/farm-orders">
                                    <i className="ti ti-books"></i>
                                </NavLink>
                            </div>
                        </li>
                        <li className="sidebar-main-menu">
                            <div className="icon-link">
                                <NavLink to="/farm-transport">
                                    <i className="ti ti-truck-delivery"></i>
                                </NavLink>
                            </div>
                        </li>
                        <li className="sidebar-main-menu">
                            <div className="icon-link">
                                <NavLink to="/farm-routing">
                                    <i className="ti ti-route"></i>
                                </NavLink>
                            </div>
                        </li>
                        <li className="sidebar-main-menu">

                            <div className="icon-link">
                                <NavLink to={"/farm-configuration"} >
                                    <i className="ti ti-settings"></i>
                                </NavLink>
                            </div>
                        </li>
                    </>
                }
                {role === 'logistic' &&
                    <li className="active sidebar-main-menu">
                        <div className="icon-link">
                            <a href="#">
                                <i className="ti ti-calendar-month"></i>
                                <span className="link_name">Order Book</span>
                            </a>
                            <i className="ti ti-chevron-down arrow"></i>
                        </div>

                        <ul className="sub-menu">
                            <li>
                                <a className="link_name" href="/order-book">Order Book</a>
                            </li>
                            <div className="bottom-divider"></div>
                            <li><a href="/inventory">Inventory</a></li>
                            <li>
                                <a href="/vendors">Vendors</a>
                            </li>
                            <li>
                                <a href="/routing">Routing</a>
                            </li>
                        </ul>
                    </li>
                }
            </ul>
        </div>
    );
}

export default SideBar;